<template>
  <div>
    <a class="btn text-themed go-back" @click="goBack()">{{ $t("flexben.general.go_back") }}</a>
    <div class="row">
      <div class="col-12 col-md-6 flexben-page-title">
        <h1>{{ (formAction==='create') ? $t('flexben.benefit_groups.new') : $t('flexben.benefit_groups.edit') }}</h1>
      </div>
      <div class="col-12 col-md-6 d-inline-flex">
        <span class="ml-md-auto">
        <button class="btn btn-delete text-danger" @click="modalAct('delete')"
                v-if="formAction==='update' && !formData.is_default">
          <font-awesome-icon icon="trash-alt"/>
          {{ $t('flexben.general.delete') }}
        </button>
          <button class="btn btn-themed px-4" @click="modalAct('form_submit')">{{ $t('flexben.general.btn.save') }}
        </button>
        </span>
      </div>
    </div>
    <div class="row mt-1" v-if="checkNotEmptyObj(errorsBag)" ref="formErrorsBanner">
      <div class="col-12">
        <div class="alert alert-danger alert-dismissible mb-0">
          <button type="button" class="close" data-dismiss="alert" @click="closeErrorButton = false">&times;</button>
          <form-error-list :errorBag="errorsBag"></form-error-list>
        </div>
      </div>
    </div>
    <div class="container-bg-white">
      <div class="row p-3">
        <div class="col-12">
          <h3 class="mt-0 pt-0 pl-0 mb-1">{{ $t('flexben.general.details') }}</h3>
        </div>
        <div class="col-12 col-md-6 col-xl-4 mt-2">
          <div>
            <span class="col-form-label">{{ $t("flexben.benefit_groups.fields.type") }}:</span>&nbsp;
            <span>{{ formData.is_default ? $t("flexben.benefit_groups.types.default") : $t("flexben.benefit_groups.types.not_default") }}</span>
          </div>
        </div>
        <div class="col-12 col-md-6 col-xl-8 mt-2">
          <div class="">
            {{ $t("flexben.benefit_groups.fields.benefit_type") }}:
          </div>
          <div class="form-check" v-for="(benefit_type) in benefit_types" :key="benefit_type">
            <input class="form-check-input cursor-pointer" type="radio" :id="'benefit_type_'+benefit_type"
                   v-model.number="formData.benefit_type" :value="benefit_type"
                   :disabled="formAction==='update'"
                   checked>
            <label class="form-check-label cursor-pointer" :for="'benefit_type_'+benefit_type">
              {{ $t("flexben.benefit_groups.benefit_types."+benefit_type) }}
            </label>
          </div>
        </div>
        <div class="col-12 col-md-6 col-xl-4 mt-2">
          <div class="form-group">
            <label for="group_name" class="form-fields-required col-form-label">{{
              $t("flexben.benefit_groups.fields.group")
              }}</label>
            <input id="group_name" type="text" class="form-control" v-model="formData.name"
                   :class="{'border-danger':(Object.keys(errorsBag).includes('group_name'))}">
          </div>
        </div>
        <div class="col-12 col-md-6 col-xl-4 mt-2">
          <div class="form-group" v-if="formAction==='update'">
            <label for="group_ode" class="col-form-label">{{ $t("flexben.benefit_groups.fields.code") }}</label>
            <input id="group_ode" type="text" class="form-control" :value="formData.code" disabled>
          </div>
        </div>
      </div>
    </div>
    <legislated-custom-benefits v-if="formData.benefit_type===1"
                       :currentLang="currentLang"
                       :formAction="formAction"
                       :benefits="benefits"
                       :formData="formData"
                       :form-errors="errorsBag"
                       :cash-out-start-local="cashOutStartLocal"
                       :cash-out-end-local="cashOutEndLocal"
                       @update-cash-out-start="handleCashOutStartInput"
                       @update-cash-out-end="handleCashOutEndInput"
                       @reset-cash-out-schedule="resetCashOutSchedule"></legislated-custom-benefits>

    <fixed-benefits v-if="formData.benefit_type===2"
                    :currentLang="currentLang"
                    :formAction="formAction"
                    :benefits="benefits"
                    :formData="formData"></fixed-benefits>

    <div class="row my-3">
      <div class="col-12 d-inline-flex">
        <span class="ml-md-auto">
        <button class="btn btn-delete text-danger" @click="modalAct('delete')"
                v-if="formAction==='update' && !formData.is_default">
          <font-awesome-icon icon="trash-alt"/>
          {{ $t('flexben.general.delete') }}
        </button>
          <button class="btn btn-themed px-4" @click="modalAct('form_submit')">{{ $t('flexben.general.btn.save') }}
        </button>
        </span>
      </div>
    </div>
    <ScrollToTopBtn/>
    <confirm-modal :openModal="modalOpen"
                   :modalAction="modalAction"
                   :formSuccess="modalFormSuccess"
                   :endMessage="modalEndMessage"
                   @closeModal="closeModal"
                   @confirmAction="confirmAction"/>
  </div>
</template>

<script>
import httpFlexbenService from "@/http/http-flexben";
import i18n from "@/plugins/language/i18n";
import ConfirmModal from "@/components/flexben/benefit_groups/modals/ConfirmModal";
import FormErrorList from "@/components/fragments/FormErrorList";
import ScrollToTopBtn from "@/components/fragments/ScrollToTopBtn";
import FixedBenefits from "./partials/FixedBenefits";
import LegislatedCustomBenefits from "@/components/flexben/benefit_groups/partials/LegislatedCustomBenefits.vue";
import moment from "moment";

export default {
  name: "BenefitGroupDetail",
  components: {
    ScrollToTopBtn,
    "confirm-modal": ConfirmModal,
    "form-error-list": FormErrorList,
    "fixed-benefits": FixedBenefits,
    "legislated-custom-benefits": LegislatedCustomBenefits,
  },
  props: {
    companyId: {
      type: Number,
    },
    formAction: {
      type: String,
      required: true,
    },
    groupId: {
      type: Number,
    },
  },
  data() {
    return {
      isAdmin: false,
      httpService: httpFlexbenService.benefitGroup,
      initialLoading: false,
      loading: false,
      loaderError: false,
      currentLang: i18n.locale,
      benefits: {
        legislated: [],
        non_legislated: [],
        fixed_benefits: [],
        custom: [],
      },
      formData: {
        id: null,
        company: null,
        benefit_type: null,
        name: '',
        code: '',
        is_default: false,
        benefit_ids: [],
        cash_out_start_at: null,
        cash_out_end_at: null,
      },
      cashOutStartLocal: '',
      cashOutEndLocal: '',
      cashOutStartTouched: false,
      benefit_types: [],
      isFormModified: false,
      errorsBag: {},
      modalOpen: false,
      modalFormSuccess: false,
      modalAction: '',
      modalEndMessage: '',
      readMoreBenId: null,
    }
  },
  watch: {
    formData: {
      deep: true,
      handler: function () {
        this.isFormModified = true;
      }
    },
    'formData.benefit_type': {
      deep: true,
      handler: function () {
        if (this.formAction === 'create') {
          this.formData.benefit_ids = [];
        }
      }
    },
  },
  computed: {
    cashOutBenefitId() {
      const benefits = [
        ...(this.benefits.legislated || []),
        ...(this.benefits.non_legislated || []),
      ];
      const cashOutBenefit = benefits.find((benefit) => benefit.sub_type === 'cash_out');

      return cashOutBenefit ? cashOutBenefit.id : null;
    },
    isCashOutAllocated() {
      return this.cashOutBenefitId !== null
        && this.formData.benefit_ids.includes(this.cashOutBenefitId);
    },
  },
  created() {
    this.isAdmin = this.flxUserLevel().userLevel === 'admin';
    this.toggleParentLoading(true);
    if (this.formAction === 'update' && this.groupId !== null) {
      this.getGroup();
    } else if (this.formAction === 'create') {
      this.getCompanyOptions();
    } else {
      this.$emit('clearForm')
    }
  },
  mounted() {
    this.isFormModified = false;
  },
  methods: {
    toDateInput(value) {
      if (!value) {
        return '';
      }
      const parsed = moment(value);
      return parsed.isValid() ? parsed.format('YYYY-MM-DD') : '';
    },
    fromDateInput(value, boundary) {
      if (!value) {
        return null;
      }
      const parsed = moment(value, 'YYYY-MM-DD', true);
      if (!parsed.isValid()) {
        return null;
      }

      return boundary === 'end'
        ? parsed.endOf('day').format('YYYY-MM-DD HH:mm:ss')
        : parsed.startOf('day').format('YYYY-MM-DD HH:mm:ss');
    },
    handleCashOutStartInput(value) {
      this.cashOutStartLocal = value;
      this.formData.cash_out_start_at = this.fromDateInput(value, 'start');
      if (value) {
        this.cashOutStartTouched = true;
      }
    },
    handleCashOutEndInput(value) {
      this.cashOutEndLocal = value;
      this.formData.cash_out_end_at = this.fromDateInput(value, 'end');
    },
    resetCashOutSchedule() {
      this.cashOutStartLocal = '';
      this.cashOutEndLocal = '';
      this.formData.cash_out_start_at = null;
      this.formData.cash_out_end_at = null;
      this.cashOutStartTouched = false;
    },
    validateCashOutSchedule() {
      if (!this.isCashOutAllocated) {
        return {};
      }

      const errors = {};
      const start = this.formData.cash_out_start_at;
      const end = this.formData.cash_out_end_at;
      const hasStart = !!start;
      const hasEnd = !!end;

      if (!hasStart && !hasEnd) {
        return errors;
      }

      if ((hasStart && !hasEnd) || (!hasStart && hasEnd)) {
        if (!hasStart) {
          errors.cash_out_start_at = 'required';
        }
        if (!hasEnd) {
          errors.cash_out_end_at = 'required';
        }
        return errors;
      }

      const startMoment = moment(start);
      const endMoment = moment(end);
      if (!startMoment.isValid()) {
        errors.cash_out_start_at = 'invalid';
      }
      if (!endMoment.isValid()) {
        errors.cash_out_end_at = 'invalid';
      }
      if (errors.cash_out_start_at || errors.cash_out_end_at) {
        return errors;
      }

      if (endMoment.isBefore(startMoment)) {
        errors.cash_out_start_at = 'invalid_range';
        errors.cash_out_end_at = 'invalid_range';
      }

      return errors;
    },
    getGroup() {
      this.httpService.details(this.groupId)
        .then(function (response) {
          this.formData.id = response.data.group.id;
          this.formData.name = response.data.group.name;
          this.formData.code = response.data.group.code;
          this.formData.benefit_type = response.data.group.benefit_type;
          this.formData.is_default = response.data.group.is_default;
          this.formData.benefit_ids = response.data.group.benefit_ids;
          this.formData.cash_out_start_at = response.data.group.cash_out_start_at || null;
          this.formData.cash_out_end_at = response.data.group.cash_out_end_at || null;
          this.cashOutStartLocal = this.toDateInput(this.formData.cash_out_start_at);
          this.cashOutEndLocal = this.toDateInput(this.formData.cash_out_end_at);
          this.cashOutStartTouched = !!this.formData.cash_out_start_at;
          this.formData.company = this.companyId;
          this.benefits.legislated = response.data.company_options.legislated_benefits;
          this.benefits.non_legislated = response.data.company_options.non_legislated_benefits;
          this.benefits.fixed_benefits = response.data.company_options.fixed_benefits;

          if (this.isAdmin) {
            this.benefits.custom = response.data.company_options.custom_benefits;
          }

          this.benefit_types = response.data.company_options.benefit_types;
          this.toggleParentLoading(false);
        }.bind(this))
        .catch(function () {
          this.toggleParentLoading(true, true);
        }.bind(this))
        .then(function () {
          this.isFormModified = false;
          this.initialLoading = true;
        }.bind(this));
    },
    getCompanyOptions() {
      this.httpService.createOptions({company: this.companyId})
        .then(function (response) {
          this.benefits.legislated = response.data.company_options.legislated_benefits;
          this.benefits.non_legislated = response.data.company_options.non_legislated_benefits;
          this.benefits.fixed_benefits = response.data.company_options.fixed_benefits;
          if (this.isAdmin) {
            this.benefits.custom = response.data.company_options.custom_benefits;
          }
          this.benefit_types = response.data.company_options.benefit_types;
          this.formData.company = this.companyId;
          this.toggleParentLoading(false);
        }.bind(this))
        .catch(function () {
        }.bind(this))
        .then(function () {
          this.isFormModified = false;
        }.bind(this));
    },
    goBack() {
      if (this.isFormModified) {
        this.modalAct('go_back')
      } else {
        this.$emit('clearForm');
      }
    },
    modalAct(action) {
      if (action === 'form_submit') {
        const scheduleErrors = this.validateCashOutSchedule();
        if (Object.keys(scheduleErrors).length > 0) {
          this.errorsBag = scheduleErrors;
          this.scrollToFormErrors();
          return;
        }
      }
      this.modalAction = action;
      this.modalOpen = true;
    },
    scrollToFormErrors() {
      this.$nextTick(function () {
        const el = this.$refs.formErrorsBanner;
        if (el && el.scrollIntoView) {
          el.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
      }.bind(this));
    },
    confirmAction(action) {
      if (action === 'go_back') {
        this.closeModal();
        this.isFormModified = false;
        this.goBack();
      }
      if (action === 'form_submit') {
        this.toggleParentLoading(true);
        this.modalOpen = false;
        if (this.modalAction === 'form_submit') {
          if (this.formAction === 'update') {
            this._updateGroup();
          } else {
            this._createGroup();
          }
        } else if (this.modalAction === 'delete') {
          this._deleteGroup();
        }
      }
      if (action === 'end') {
        this.closeModal();
        if (this.modalFormSuccess) {
          this.isFormModified = false;
          this.$emit('clearForm', true);
        }
      }
    },
    closeModal() {
      this.modalAction = '';
      this.modalOpen = false;
    },
    toggleParentLoading(toggle, loaderError = false) {
      this.$emit('triggerLoading', toggle, loaderError);
    },
    _updateGroup() {
      this.errorsBag = {};
      this.httpService.update(this.formData.id, this.formData)
        .then(function () {
          this.modalFormSuccess = true;
          this.modalAction = 'end';
          this.toggleParentLoading(false);
          this.modalOpen = true;
        }.bind(this))
        .catch(function (error) {
          this.modalFormSuccess = false;
          if (error.response.status === 400) {
            this.errorsBag = error.response.data.error_fields;
            this.toggleParentLoading(false);
          } else if (500 <= error.response.status && error.response.status < 600) {
            this.toggleParentLoading(true, true);
          }
        }.bind(this));
    },
    _deleteGroup() {
      this.errorsBag = {};
      this.httpService.delete(this.formData.id)
        .then(function () {
          this.modalFormSuccess = true;
          this.modalAction = 'end';
          this.toggleParentLoading(false);
          this.modalOpen = true;
        }.bind(this))
        .catch(function (error) {
          this.modalFormSuccess = false;
          if (error.response.status === 400) {
            this.errorsBag = error.response.error_fields;
            this.toggleParentLoading(false);
          } else if (500 <= error.response.status && error.response.status < 600) {
            this.toggleParentLoading(true, true);
          }
        }.bind(this));
    },
    _createGroup() {
      this.errorsBag = {};
      this.httpService.create(this.formData)
        .then(function () {
          this.modalFormSuccess = true;
          this.modalAction = 'end';
          this.toggleParentLoading(false);
          this.modalOpen = true;
        }.bind(this))
        .catch(function (error) {
          this.modalFormSuccess = false;
          if (error.response.status === 400) {
            this.errorsBag = error.response.data.error_fields;
            this.toggleParentLoading(false);
          } else if (500 <= error.response.status && error.response.status < 600) {
            this.toggleParentLoading(true, true);
          }
        }.bind(this));
    }
  }
}
</script>
